import React, {useRef } from 'react';
import { formatFecha} from "../../../../shared/utils/utils";
import {UsePermissions} from "../../../../hooks/usePermissions";
import {Toast} from "primereact/toast";
import {ContainerTitleTable} from "../../../../components/Containers/ContainerTitleTable";
import {ContainerTable} from "../../../../components/Containers/ContainerTable";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {confirmDialog} from "primereact/confirmdialog";
import {devolverFactura} from "../../../../api/liquidacion.service";
import {UseLoader} from "../../../../hooks/useLoader";

export const TableDevolucionPagos = ({pagados, reload}) => {
    const [permisos] = UsePermissions()

    const [handleLoad] = UseLoader();
    const toast = useRef(null);


    const datePagoBodyTemplate = (rowData) => {
        return formatFecha(rowData.fecha_pago)
    }
    const dateCreaBodyTemplate = (rowData) => {
        return formatFecha(rowData.fecha_crea)
    }

    const devolverPago = (rowData) => {

        try {
            confirmDialog({
                message: '¿Estas seguro?',
                header: 'Confirmación',
                acceptLabel: "Si",
                rejectLabel: "No",
                accept: async () => {

                    handleLoad(true);
                    const payload = {
                        factura_id: rowData.factura_id,
                    }
                    const response = await devolverFactura(payload);

                    handleLoad(false)


                if (response.estado !== 200) {
                        toast.current?.show({
                            severity: 'error',
                            summary: 'Alerta',
                            detail: response.mensaje,
                            life: 3000
                        });
                        return;
                    }

                    toast.current?.show({severity: 'success', summary: 'Exito', detail: response.mensaje, life: 3000});
                    reload()
                }
            });

        } catch (e) {
            handleLoad(false);
            console.log(e);
        }
    }

    const actionTemplate = function (rowData) {
        return (
            <div className="flex align-items-center justify-start">

                <button
                    disabled={(!permisos.editar)}
                    className="btn danger-color-btn"
                    type="button"
                    onClick={() => devolverPago(rowData)}>
                    <i className="fa fa-trash"/>
                </button>
            </div>
        );
    }
    return (
        <>
            <Toast ref={toast}/>
            <ContainerTitleTable>
                {permisos.submenu}
            </ContainerTitleTable>

            <ContainerTable>
                <DataTable
                    showGridlines
                    resizableColumns
                    columnResizeMode="expand"

                    size="small"
                    value={pagados}
                    scrollable scrollHeight="400px"
                    filterDisplay="menu"
                    totalRecords={pagados.length == undefined || pagados.length === 0 ? 0: pagados.length}

                    responsiveLayout="scroll">
                    <Column header="Editar" style={{fontSize: ".8em"}} body={actionTemplate}></Column>
                    <Column field="nombre" sortable  filter header="Cliente"   showFilterMatchModes={false}
                           ></Column>
                    <Column field="fecha_pago" sortable  filter header="Fecha de pago" body={datePagoBodyTemplate} sortable  showFilterMatchModes={false}
                            onFilterClear={reload}></Column>
                    <Column field="anio" header="Año" sortable  filter  showFilterMatchModes={false}
                            onFilterClear={reload}></Column>
                    <Column field="mes" header="Mes" sortable  filter   showFilterMatchModes={false}
                            onFilterClear={reload}>

                    </Column>
                    <Column field="periodo" header="Periodo" sortable  filter   showFilterMatchModes={false}
                            onFilterClear={reload}></Column>
                    <Column field="fecha_crea" header="Fecha Creación" body={dateCreaBodyTemplate} sortable  showFilterMatchModes={false}
                            onFilterClear={reload}></Column>


                </DataTable>
            </ContainerTable>
        </>
    );
};

